module.exports = __webpack_public_path__ + "img/222929-new.90c41c5c.webp";